<script>
import moment from 'moment';

export default {
  props: ['filters','found','theuser'],
  data() {
    return {

      loading: true,
      results: [],
      pagination: {},
    }
  },
  watch: {
    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {

  },
  mounted() {
    if(this.theuser && this.theuser.ip_addresses && this.theuser.ip_addresses.constructor === Array && this.theuser.ip_addresses.length > 0) {
      this.filters.searchips = this.theuser.ip_addresses;
    } else if(this.theuser && this.theuser.id) {
      this.filters.wheres.user_id = this.theuser.id;
    }
    if(this.found) {
      this.results = this.found;
    } else {
      this.fetchData();
    }

    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      console.log(this.filters);
      if((this.filters.searchips && this.filters.searchips.length > 0) || this.filters.wheres.tracker_id || this.filters.wheres.user_id){
        this.loading = true;
        this.filters.page = this.pagination.current_page;
        this.$http.get('/api/pageviews/fetch', {params: this.filters}).then(res => {
          // console.log(res);
          this.results = res.data.data;
          this.pagination = res.data;
          this.filters.total = res.data.total;
          this.loading = false;
        }).catch(res => { this.loading = false; this.popupErrors(res); });
      }
    },
    getUserArray(views) {
      var users = [];
      var output = "";
      // console.log(views);
      for(var i in views) {
        if(views[i].user && !users[views[i].user.name]) {
          users[views[i].user.name] = "1";
          if(!output) { output = output+""+views[i].user.name; } else { output = output+", "+views[i].user.name; }

        }
      }
      return output;
    }

  }
}
</script>

<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="table-responsive m-0">
        <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
          <thead class="bg-white">
            <tr>
              <th>Website</th>
              <th>Domain</th>
              <th>Page</th>
              <th>Query string</th>
              <th>Tracker ID</th>
              <th>Referring domain</th>
              <th>Referring URL</th>
              <th>Browser</th>
              <th>Operating system</th>
              <th>User agent</th>
              <th>Created on</th>
            </tr>
            <tr class="sticky-thead bg-white">
              <th>Website</th>
              <th>Domain</th>
              <th>Page</th>
              <th>Query string</th>
              <th>Tracker ID</th>
              <th>Referring domain</th>
              <th>Referring URL</th>
              <th>Browser</th>
              <th>Operating system</th>
              <th>User agent</th>
              <th>Created on</th>
            </tr>
          </thead>
          <tbody class="">
            <tr v-for="(item, index) in results" :key="item.id" :class="item.user_agent && item.user_agent.includes('bot') ? 'alert-danger' : ''" v-tippy :content="item.user_agent && item.user_agent.includes('bot') ? 'Possible bot' : ''">
              <td>{{item.website}}</td>
              <td>{{item.domain}}</td>
              <td>{{item.page}}</td>
              <td>{{item.query_string}}</td>
              <td>{{item.tracker_id}}</td>
              <td>{{item.referring_domain}}</td>
              <td>{{item.referrer}}</td>
              <td>{{item.browser}}</td>
              <td>{{item.os}}</td>
              <td>{{item.user_agent}}</td>
              <td v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td>
            </tr>
          </tbody>
        </table>
        <div class="p-2 border-top border-light">
          <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
